/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manageyourpasswordandsecuritysettings5Inputs */

const en_manageyourpasswordandsecuritysettings5 = /** @type {(inputs: Manageyourpasswordandsecuritysettings5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your password and security settings`)
};

const de_manageyourpasswordandsecuritysettings5 = /** @type {(inputs: Manageyourpasswordandsecuritysettings5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalte dein Passwort und deine Sicherheitseinstellungen`)
};

/**
* | output |
* | --- |
* | "Manage your password and security settings" |
*
* @param {Manageyourpasswordandsecuritysettings5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const manageyourpasswordandsecuritysettings5 = /** @type {((inputs?: Manageyourpasswordandsecuritysettings5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manageyourpasswordandsecuritysettings5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manageyourpasswordandsecuritysettings5(inputs)
	return de_manageyourpasswordandsecuritysettings5(inputs)
});
export { manageyourpasswordandsecuritysettings5 as "manageYourPasswordAndSecuritySettings" }